export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null
  const match = new RegExp(`(^| )${name}=([^;]+)`).exec(document.cookie)
  return match ? decodeURIComponent(match[2]) : null
}

export function getSelectedRestaurantId(): number | null {
  if (typeof localStorage === 'undefined') return null

  try {
    const raw = localStorage.getItem('selectedRestaurant')
    if (!raw) return null
    const parsed = JSON.parse(raw) as { id?: unknown }
    const id = Number(parsed.id)
    return Number.isInteger(id) && id > 0 ? id : null
  } catch {
    return null
  }
}
